import * as React from "react";
import styles from "./Gallery.module.css";
import Header from "../../Components/Layout/Header";
import {
  Box,
  Container,
  createTheme,
  Grid,
  Typography,
  Tab,
} from "@mui/material";
import GalleryTab from "../../Components/Tabs/GalleryTab";
import Footer from "../../Components/Layout/Footer";
import { Fade } from "react-slideshow-image";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { useEffect, useState } from "react";
import Parse from "../../API/ParseServer";
import { Link } from "react-router-dom";
const indicators = (index: any) => <li className={styles.indicator}></li>;
const properties = {
  prevArrow: <ArrowBackIosRoundedIcon className={styles.arrow} />,
  nextArrow: <ArrowForwardIosRoundedIcon className={styles.arrow} />,
};

const Gallery = () => {
  const [slider, setSlider] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSlider = async () => {
      const query = new Parse.Query("Slider");
      query.equalTo("page", "gallery");
      try {
        const results = await query.find();
        if (results.length > 0) {
          console.log(results);
          setSlider(results);
        } else {
          throw new Error("Slider not found.");
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSlider();
  }, []);

  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#dad9da",
          pb: 7,
          pt: 5,
        }}
      >
        <Container>
          {slider && (
            <Fade
              onChange={function noRefCheck() {}}
              onStartChange={function noRefCheck() {}}
              indicators={indicators}
              {...properties}
              duration={4000}
              transitionDuration={800}
            >
              {slider.map((slide: any) => (
                <Grid container sx={{ width: "100%" }}>
                  <Grid item xs={12} md={6} sx={{ width: "100%" }}>
                    <Typography
                      component="h2"
                      variant="h3"
                      sx={{ width: "100%" }}
                    >
                      {slide.get("title")}
                    </Typography>
                    <br />
                    <br />
                    {slide.get("description").map((item: string) => (
                      <Typography>
                        {item}
                        <br />
                      </Typography>
                    ))}

                    {slide.get("buttonTitle") && (
                      <Box className={styles.buttons}>
                        <Link
                          to={`${slide.get("buttonTarget")}`}
                          style={{ display: "block" }}
                        >
                          <button> {slide.get("buttonTitle")}</button>
                        </Link>
                      </Box>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {slide.get("image") ? (
                      <img
                        src={slide.get("image").url()}
                        alt={slide.get("title")}
                        className={styles["slider-image"]}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: "85%",
                          aspectRatio: "4/3",
                          backgroundColor: "gray",
                        }}
                      ></Box>
                    )}
                  </Grid>
                </Grid>
              ))}
            </Fade>
          )}
        </Container>
      </Box>
      <Container sx={{ mb: 20 }}>
        <GalleryTab />
      </Container>
    </React.Fragment>
  );
};

export default Gallery;
